if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          progressBar: this.querySelector('.product-gallery-swiper-progress__bar'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (this.elements.viewer) {
          this.slider = this.elements.viewer.querySelector('.slider');
        }

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          
          if (this.slider && this.elements.progressBar) {
            this.slider.addEventListener('scroll', this.updateSmoothSegmentedProgress.bind(this), { passive: true });
            window.addEventListener('resize', this.updateSmoothSegmentedProgress.bind(this));
          }
        }

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
        }

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        if (this.elements.viewer) {
          requestAnimationFrame(() => this.updateSmoothSegmentedProgress());
        }
      }

      updateSmoothSegmentedProgress() {
        if (!this.elements.progressBar || !this.slider) return;

        const slides = this.slider.querySelectorAll('.slider__slide');
        const itemCount = slides.length;

        if (itemCount <= 1) {
          this.elements.progressBar.parentElement.style.display = 'none';
          return;
        }

        const barWidthPercent = 100 / itemCount;
        this.elements.progressBar.style.width = `${barWidthPercent}%`;

        const firstSlide = slides[0];
        const lastSlide = slides[itemCount - 1];

        // AANGEPAST: Dit pakt de exacte padding marge van het thema en haalt deze ervanaf!
        const startOffset = firstSlide.offsetLeft;
        const endOffset = lastSlide.offsetLeft;
        
        let trueMaxScroll = endOffset - startOffset;
        
        if (trueMaxScroll <= 0) {
          trueMaxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        }

        // Trek de startOffset van de scroll af, zodat hij exact op 0 begint
        let currentScroll = this.slider.scrollLeft - startOffset;

        // Forceer tussen 0 en max (voorkomt glitches als Apple gebruikers hard naar links bouncen)
        currentScroll = Math.max(0, Math.min(currentScroll, trueMaxScroll));

        const scrollPercentage = currentScroll / trueMaxScroll;

        const currentTranslate = scrollPercentage * (itemCount - 1) * 100;
        this.elements.progressBar.style.transform = `translateX(${currentTranslate}%)`;
      }

      getCurrentPage() {
        if (!this.elements.viewer) return 1;

        if (this.elements.viewer.currentPage) {
          return this.elements.viewer.currentPage;
        }

        const slides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));

        return activeIndex >= 0 ? activeIndex + 1 : 1;
      }

      getTotalPages() {
        if (!this.elements.viewer) return 1;

        if (this.elements.viewer.totalPages) {
          return this.elements.viewer.totalPages;
        }

        return this.elements.viewer.querySelectorAll('[data-media-id]').length || 1;
      }

      updateProgress(currentPage) {
        this.updateSmoothSegmentedProgress();
      }

      onSlideChanged(event) {
        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        const currentPage = event?.detail?.currentPage || this.getCurrentPage();
        this.updateProgress(currentPage);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail) {
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
          }
        }

        const slides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const currentSlide = slides.findIndex((element) => element.dataset.mediaId === mediaId);

        if (currentSlide >= 0) {
          this.updateProgress(currentSlide + 1);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer || !this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}